<template>
  <div class="main">
    <div class="o-main-content">
      <home></home>
    </div>
  </div>
</template>
<script>
import Home from '@/page/userCenter/home.vue'
export default {
  name: 'homemenu',
  components: {
    'home': Home
  },
  data () {
    return {
      currentPage: 1
    }
  }
}
</script>

<style lang="less">
.main{
  position: relative;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/page/userCenter/HomeMenu.vue